import React from "react";
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Search, SlidersHorizontal } from "lucide-react";

export default function FiltersBar({
  sharedFilters,
  setSharedFilters,
  lawyers,
  handleApply,
  handleClear,
}) {
  return (
    <Grid item xs={12}>
      <Grid container spacing={1}>
        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Deshabilitado</InputLabel>
            <Select value={sharedFilters.lawyer_id} disabled>
              <MenuItem value="">Todos</MenuItem>
              {lawyers.map((l) => (
                <MenuItem key={l.id} value={l.id}>
                  {l.name} {l.surname}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}

        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="Asunto"
            value={sharedFilters.subject}
            onChange={(e) =>
              setSharedFilters((s) => ({ ...s, subject: e.target.value }))
            }
          />
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <Button
            variant="outlined"
            startIcon={<SlidersHorizontal />}
            onClick={handleClear}>
            Limpiar
          </Button>
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={handleApply}>
            Aplicar filtros
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}
